export default __webpack_public_path__ + "static/media/CMEDefault.8c0d76ce.svg";